import React from 'react';
import Bg from '../../../Assets/Backgrounds/ipadBanner.webp';
import AppsBanner from '../../Shared/AppsBanner/AppsBanner';
import {ReactComponent as Btn1 } from '../.././../Assets/Icons/ipad1.svg';
const Banner=()=>{
    return(
        <>
        <AppsBanner
        title="Never present static designs again, prototypes communicate ideas better"
        backgroundImage = {Bg}
        btn1={<Btn1 />}
        />
        </>
    )
};
export default Banner ;